import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  bulkSendToContacts,
  listTemplates,
  sendContactMessage,
  sendDealMessage,
  type BulkSendInput,
  type SendMessageInput,
} from '@/api/messages'

export function useTemplates(channel?: string) {
  return useQuery({
    queryKey: ['templates', channel ?? 'all'],
    queryFn: () => listTemplates(channel),
  })
}

export function useBulkSend() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: BulkSendInput) => bulkSendToContacts(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['contacts'] })
      qc.invalidateQueries({ queryKey: ['analytics', 'email'] }) // the dashboard's sent count
    },
  })
}

export function useSendMessage(dealId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: SendMessageInput) => sendDealMessage(dealId, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['activities', dealId] })
      qc.invalidateQueries({ queryKey: ['deal', dealId] })
      qc.invalidateQueries({ queryKey: ['attention'] })
      qc.invalidateQueries({ queryKey: ['dashboard'] })
    },
  })
}

export function useSendContactMessage(contactId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: SendMessageInput) => sendContactMessage(contactId, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['contact-activities', contactId] })
      qc.invalidateQueries({ queryKey: ['contacts'] }) // lastContactedAt may change
      qc.invalidateQueries({ queryKey: ['attention'] })
      qc.invalidateQueries({ queryKey: ['dashboard'] })
    },
  })
}
